'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var clone = function clone(obj) {
  if (obj === null || (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object') return obj;
  if (Array.isArray(obj)) {
    var out = [];
    var len = obj.length;
    for (var i = 0; i < len; i += 1) {
      out[i] = clone(obj[i]);
    }
    return out;
  }
  var copy = {};
  Object.keys(obj).forEach(function (key) {
    // https://eslint.org/docs/2.13.1/rules/no-prototype-builtins
    if ({}.hasOwnProperty.call(obj, key)) {
      copy[key] = clone(obj[key]);
    }
  });
  return copy;
};

exports.default = clone;


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/utilities/clone.js
// module id = 388
// module chunks = 4